import { clsx } from "clsx";

import { Border } from "~/components/border";
import { FadeIn, FadeInStagger } from "~/components/fade-in";

export function List({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <FadeInStagger>
      <ul className={clsx("text-base text-ink-300", className)}>{children}</ul>
    </FadeInStagger>
  );
}

export function ListItem({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string;
}) {
  return (
    <li className="group mt-8 first:mt-0">
      <FadeIn>
        <Border className="pt-8 group-first:pt-0 group-first:before:hidden group-first:after:hidden">
          {title ? (
            <strong className="font-semibold text-ink-50">{`${title}. `}</strong>
          ) : null}
          {children}
        </Border>
      </FadeIn>
    </li>
  );
}
